import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    margin: '5px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, onClickAction }) => {
  return (
    <Button
      variant="contained"
      color="secondary"
      className={classes.button}
      onClick={onClickAction}
    >
      グループ運営会社
      <br />
      新規登録
    </Button>
  );
});

export default withStyles(styles)(button);
